import { render, staticRenderFns } from "./CreateAnnouncement.vue?vue&type=template&id=5d13eb43&scoped=true"
import script from "./CreateAnnouncement.vue?vue&type=script&lang=js"
export * from "./CreateAnnouncement.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d13eb43",
  null
  
)

export default component.exports